<template>
  <div>
    <ExternalPostTagDetail ref="tagDetail" />
    <el-table
      :data="tableData"
      stripe
      size="small"
      style="width: 100%"
      :default-sort="{ prop: 'content', order: 'ascending' }"
    >
      <el-table-column align="center" prop="plp" :label="$t('plp')" width="120" />
      <el-table-column prop="tag" :label="$t('etiqueta')" width="160">
        <template slot-scope="scope">
          <TagLink :tag="scope.row.tag" back="plp.external" />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="weight" :label="$t('peso')" width="80" />
      <el-table-column prop="service" :label="$t('servico')" />
      <el-table-column prop="name" :label="$t('destinatario')" />
      <el-table-column align="center" prop="zipcode" :label="$t('cep')" width="80" />
      <el-table-column align="center" prop="postedAt" :label="$t('data')" width="100" />
      <el-table-column align="right" prop="value" :label="$t('valor')" width="120">
        <template slot-scope="scope">
              {{
                scope.row.value
                  | currency("R$ ", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                  })
              }}
            </template>
      </el-table-column>
      <el-table-column width="110">
          <template slot-scope="scope">
            <el-button
              type="primary"
              title="Imprimir essa etiqueta"
              icon="el-icon-printer"
              @click="print(scope.$index, scope.row)"
              circle
            ></el-button>
            <el-button
              type="warning"
              title="Detalhes desse objeto"
              icon="el-icon-more"
              @click="view(scope.$index, scope.row)"
              circle
            ></el-button>
          </template>
        </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { ExternalService } from "@/services/customers/external.services";
import "moment/locale/pt-br";
import ExternalPostTagDetail from './ExternalPostTagDetail';
import TagLink from './TagLink.vue';

export default {
  props: ["tableData"],
  components: {
    ExternalPostTagDetail, TagLink,
  },
  methods: {
    print(index, row) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ExternalService.print(row.id)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response.data;
          downloadLink.download = `${row.tag}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());

    },
    view(index, row) {
      const vm = this;
      vm.$refs.tagDetail.open(row);
    }
  }
}
</script>

<style scoped>
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
  </style>